import React from "react";
// import { useNavigate } from "react-router-dom";
import LoginFormWrapper from "./screens/Login/LoginFormWrapper";

const AuthHOC = ({component}: {component:React.ReactNode}) => {
  const accessToken = localStorage.getItem("authToken");
  // const navigate = useNavigate();

  // React.useEffect(() => {
  //   if (!accessToken) {
  //     navigate("/login");
  //   } else {

  //   }
  // }, [accessToken, navigate]);
  return <>{accessToken ? <> {component} </> : <LoginFormWrapper />}</>;
};

export default AuthHOC;
